export const GET_ASSESSMENTS = "GET_ASSESSMENTS";
export const GET_ASSESSMENT_BY_ID = "GET_ASSESSMENT_BY_ID";
export const UPDATE_ASSESSMENT = "UPDATE_ASSESSMENT";
export const DELETE_ASSESSMENT = "DELETE_ASSESSMENT";
export const CREATE_ASSESSMENT = "CREATE_ASSESSMENT";
export const GET_ASSESSMENT_QUESTIONS = "GET_ASSESSMENT_QUESTIONS";
